import { insertIntoSupabase, selectFromSupabase, updateInSupabase, deleteFromSupabase, selectReportsRange } from "../helpers/supabase-api";

/**
 * Create a new report
 * @param {object} reportData - object containing the report data
 */
export function createReport(reportData) {
  // Map frontend structure to database structure
  const dbData = {
    from_date: reportData.from,
    to_date: reportData.to,
    data: reportData
  };
  
  return insertIntoSupabase("reports", dbData).then(result => {
    // Return in FaunaDB-compatible format for frontend compatibility
    return {
      ref: {
        value: {
          id: result.id
        }
      },
      data: {
        ...reportData,
        id: result.id
      }
    };
  });
}

export function getReports() {
  return selectFromSupabase("reports", "*").then(reports => {
    // Transform to FaunaDB-compatible format
    const transformedData = reports.map(report => ({
      ref: {
        value: {
          id: report.id
        }
      },
      data: {
        id: report.id,
        from_date: report.from_date,
        to_date: report.to_date,
        created_at: new Date(report.created_at).getTime(),
        ...report.data
      }
    }));
    
    return { data: transformedData };
  });
}

export function getReportsRange(from, to) {
  // Use the specialized reports API for proper date range filtering
  return selectReportsRange(from, to).then(reports => {
    // Transform to match the expected frontend format - reports should be an array
    // where each report contains data.blocks with the time tracking information
    const transformedData = reports.map(report => ({
      ref: {
        value: {
          id: report.id
        }
      },
      data: {
        id: report.id,
        from_date: report.from_date,
        to_date: report.to_date,
        created_at: new Date(report.created_at).getTime(),
        ...report.data
      }
    }));
    
    return { data: transformedData };
  });
}

/**
 * Delete a report
 * @param {string} id - report ID to delete
 */
export function deleteReport(id) {
  return deleteFromSupabase("reports", { id });
}

/**
 * Update a report
 * @param {string} id - report ID to update
 * @param {object} reportData - object of data to update
 */
export function updateReport(id, reportData) {
  // Map frontend data to database structure
  const dbData = {};
  if (reportData.from_date) dbData.from_date = reportData.from_date;
  if (reportData.to_date) dbData.to_date = reportData.to_date;
  
  // Store full report data in data field
  dbData.data = reportData;
  
  return updateInSupabase("reports", dbData, { id });
}
